import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeopleStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 160.05 156",
	width: "100%",
	height: "100%",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M82.74,86.01h0c8.2,0,14.82,6.72,14.82,15.18s-6.61,15.12-14.82,15.12-14.99-6.78-14.99-15.12,6.67-15.18,14.99-15.18ZM82.74,89.19h0c-6.61,0-11.81,5.28-11.81,12s5.19,11.88,11.81,11.88,11.69-5.28,11.69-11.88-5.19-12-11.69-12Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M82.74,86.01h0c8.2,0,14.82,6.72,14.82,15.18s-6.61,15.12-14.82,15.12-14.99-6.78-14.99-15.12,6.67-15.18,14.99-15.18ZM82.74,89.19h0c-6.61,0-11.81,5.28-11.81,12s5.19,11.88,11.81,11.88,11.69-5.28,11.69-11.88-5.19-12-11.69-12Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M63.49,139.51h0c0,.78-.77,1.44-1.71,1.26-.83,0-1.42-.78-1.3-1.74,1.3-11.4,10.74-20.21,22.25-20.21s21.01,8.82,22.25,20.21c0,.96-.65,1.74-1.42,1.74-.94.18-1.71-.48-1.71-1.26-1.12-9.96-9.33-17.45-19.12-17.45s-18.12,7.5-19.24,17.45Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M63.49,139.51h0c0,.78-.77,1.44-1.71,1.26-.83,0-1.42-.78-1.3-1.74,1.3-11.4,10.74-20.21,22.25-20.21s21.01,8.82,22.25,20.21c0,.96-.65,1.74-1.42,1.74-.94.18-1.71-.48-1.71-1.26-1.12-9.96-9.33-17.45-19.12-17.45s-18.12,7.5-19.24,17.45Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M111.95,98.97h0c6.43,0,11.63,5.28,11.63,11.7s-5.19,11.88-11.63,11.88-11.51-5.28-11.51-11.88,5.19-11.7,11.51-11.7ZM111.95,102.15h0c-4.6,0-8.38,3.9-8.38,8.52s3.78,8.64,8.38,8.64,8.5-3.84,8.5-8.64-3.78-8.52-8.5-8.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M111.95,98.97h0c6.43,0,11.63,5.28,11.63,11.7s-5.19,11.88-11.63,11.88-11.51-5.28-11.51-11.88,5.19-11.7,11.51-11.7ZM111.95,102.15h0c-4.6,0-8.38,3.9-8.38,8.52s3.78,8.64,8.38,8.64,8.5-3.84,8.5-8.64-3.78-8.52-8.5-8.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M105.64,128.96h0c-.83.48-1.77.12-2.24-.66-.3-.78,0-1.74.83-2.22,2.36-1.14,5.02-1.98,7.73-1.98,8.5,0,15.76,6.42,17,14.94.18.78-.47,1.74-1.24,1.74-.94.18-1.77-.48-1.89-1.26-.94-7.08-6.97-12.18-13.87-12.18-2.24,0-4.43.66-6.32,1.62Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M105.64,128.96h0c-.83.48-1.77.12-2.24-.66-.3-.78,0-1.74.83-2.22,2.36-1.14,5.02-1.98,7.73-1.98,8.5,0,15.76,6.42,17,14.94.18.78-.47,1.74-1.24,1.74-.94.18-1.77-.48-1.89-1.26-.94-7.08-6.97-12.18-13.87-12.18-2.24,0-4.43.66-6.32,1.62Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M53.4,98.97h0c6.32,0,11.51,5.28,11.51,11.7s-5.19,11.88-11.51,11.88-11.69-5.28-11.69-11.88,5.25-11.7,11.69-11.7ZM53.4,102.15h0c-4.72,0-8.5,3.9-8.5,8.52s3.78,8.64,8.5,8.64,8.38-3.84,8.38-8.64-3.78-8.52-8.38-8.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M53.4,98.97h0c6.32,0,11.51,5.28,11.51,11.7s-5.19,11.88-11.51,11.88-11.69-5.28-11.69-11.88,5.25-11.7,11.69-11.7ZM53.4,102.15h0c-4.72,0-8.5,3.9-8.5,8.52s3.78,8.64,8.5,8.64,8.38-3.84,8.38-8.64-3.78-8.52-8.38-8.52Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M39.53,139.51h0c-.18.78-.94,1.44-1.71,1.26-.94,0-1.59-.96-1.42-1.74,1.24-8.52,8.5-14.94,17-14.94,2.72,0,5.37.84,7.91,1.98.65.48.94,1.44.65,2.22-.53.78-1.48,1.14-2.24.66-1.89-.96-4.07-1.62-6.32-1.62-6.91,0-12.93,5.1-13.87,12.18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M39.53,139.51h0c-.18.78-.94,1.44-1.71,1.26-.94,0-1.59-.96-1.42-1.74,1.24-8.52,8.5-14.94,17-14.94,2.72,0,5.37.84,7.91,1.98.65.48.94,1.44.65,2.22-.53.78-1.48,1.14-2.24.66-1.89-.96-4.07-1.62-6.32-1.62-6.91,0-12.93,5.1-13.87,12.18Z"
		})
	] }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M95.47,23.41c.38.28.82.42,1.29.42.7,0,1.37-.34,1.78-.91l1.48-2.05c.34-.48.48-1.06.39-1.64-.09-.58-.41-1.08-.88-1.42-.98-.71-2.35-.49-3.06.49l-1.48,2.04c-.35.47-.49,1.05-.4,1.63.09.58.4,1.09.87,1.43Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M66.91,22.92c.41.57,1.08.9,1.78.9.47,0,.92-.15,1.29-.42.98-.71,1.2-2.08.49-3.06l-1.48-2.04c-.71-.98-2.08-1.2-3.06-.49-.98.71-1.2,2.08-.49,3.06l1.48,2.05Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M61.01,46.38c-.52-.26-1.12-.31-1.67-.13l-2.4.78c-1.14.37-1.78,1.61-1.41,2.76.29.91,1.13,1.51,2.09,1.51.24,0,.47-.04.68-.11l2.4-.78c1.14-.37,1.78-1.61,1.41-2.76-.18-.56-.57-1.01-1.09-1.27Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M97.32,45.73l8.36-8.15c1.18-1.14,1.59-2.83,1.09-4.4-.51-1.56-1.84-2.68-3.47-2.92l-11.55-1.68-5.16-10.47c-.73-1.47-2.2-2.39-3.85-2.39s-3.12.92-3.85,2.39l-5.16,10.47-11.55,1.68c-1.63.23-2.96,1.35-3.47,2.92-.51,1.56-.09,3.25,1.08,4.4l8.36,8.15-1.97,11.51c-.28,1.62.37,3.23,1.71,4.2.75.55,1.63.82,2.52.82.68,0,1.37-.16,2-.5l10.33-5.43,10.34,5.43c1.46.75,3.23.61,4.51-.33,1.33-.97,1.99-2.57,1.71-4.2l-1.97-11.51ZM95.74,57.85l-.78.14h0s.78-.14.78-.14ZM72.46,46.42c.24-1.39-.22-2.81-1.23-3.8l-8.25-8.04,11.42-1.66c1.4-.21,2.61-1.09,3.23-2.35l5.1-10.34,5.1,10.35c.63,1.27,1.84,2.15,3.23,2.35l11.41,1.66-8.25,8.04c-1.01.99-1.47,2.41-1.23,3.8l1.94,11.36-10.21-5.36c-1.25-.65-2.74-.65-3.99,0l-10.21,5.37,1.95-11.37Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M108.52,47.03l-2.4-.78c-1.15-.37-2.39.26-2.76,1.41-.38,1.15.26,2.39,1.41,2.76l2.41.78c.23.07.45.11.66.11.95,0,1.79-.61,2.09-1.52.36-1.15-.27-2.39-1.41-2.76Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M82.73,62.64c-1.21,0-2.19.98-2.19,2.19v2.52c0,1.21.98,2.19,2.19,2.19s2.19-.98,2.19-2.19v-2.52c0-.58-.22-1.13-.63-1.55-.41-.42-.97-.65-1.56-.65Z"
		})
	] })]
});
export default SvgPeopleStar;
